import type * as React from "react";
import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cn } from "../../lib/cn";

export const labelVariants = cva(
  "text-body-m-b leading-none transition-[color,opacity] duration-140 ease-emphasized peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
  {
    variants: {
      error: {
        true: "text-fail-text",
        false: "text-text",
      },
    },
    defaultVariants: {
      error: false,
    },
  },
);

export interface LabelProps
  extends
    React.ComponentProps<typeof LabelPrimitive.Root>,
    VariantProps<typeof labelVariants> {
  required?: boolean;
}

export function Label({
  className,
  error = false,
  required = false,
  children,
  ...props
}: LabelProps) {
  return (
    <LabelPrimitive.Root
      className={cn(labelVariants({ error, className }))}
      {...props}
    >
      {children}
      {required && (
        <span className="ms-1 text-fail-text" aria-hidden="true">
          *
        </span>
      )}
    </LabelPrimitive.Root>
  );
}
